import { render, staticRenderFns } from "./point-record.vue?vue&type=template&id=14b5f7e4&scoped=true&"
import script from "./point-record.vue?vue&type=script&lang=js&"
export * from "./point-record.vue?vue&type=script&lang=js&"
import style0 from "./point-record.vue?vue&type=style&index=0&id=14b5f7e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b5f7e4",
  null
  
)

export default component.exports